<script setup lang="ts">
import type { AddressObject } from 'types/footer';

const props = defineProps<{
  address?: AddressObject;
}>();

const { content } = props.address || {};
</script>

<template>
  <address
    v-if="content"
    class="mb-2 flex flex-col text-base not-italic text-black"
  >
    <p
      v-if="content.companyName"
      class="font-bold"
    >
      {{ content.companyName }}
    </p>

    <small
      v-if="content.area"
      class="mb-2 font-semibold"
    >
      {{ content.area }}
    </small>

    <p
      v-if="content.address"
      class="mb-2"
    >
      {{ content.address }}
    </p>

    <p
      v-if="content.zip"
      class="mb-2"
    >
      {{ content.zip }}
      <template v-if="content?.city">{{ content.city }}</template>
    </p>

    <div
      v-if="content.googleMapsLink?.url"
      class="flex items-start"
    >
      <BaseIcon
        name="map-marker"
        class="size-6"
        fill-color="var(--color-black)"
      />
      <BaseLink
        :to="content.googleMapsLink.url"
        :target="content.googleMapsLink.target"
        class="text-gray-70 underline"
        :aria-label="$t('Aria.Global.Footer.FindOnGoogleMaps')"
      >
        {{ content.googleMapsLink.name }}
      </BaseLink>
    </div>
  </address>
</template>
